import React, { useState } from "react";
import "./styles.css";
import { Spinner } from "react-bootstrap";
import Slider from "./Slider";
import Fade from "react-reveal/Fade";
import face from "../../Assets/icons/facebook.svg";
import insta from "../../Assets/icons/insta.svg";
import twitter from "../../Assets/icons/twitter.svg";
import axios from "axios";

const validateEmail = (email) => {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
};
const API_URL = "https://api.aorthar.tech";
const JustForSection = () => {
  const [email, setEmail] = useState("");
  const [color, setColor] = useState("");
  const [message, setMessage] = useState("");
  const [messageboo, setMessageboo] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateEmail(email)) {
      setLoading(true);
      axios
        .post(`${API_URL}/newsletter`, email)
        .then((res) => {
          setLoading(false);
          if (res.data.error) {
            setColor("red");
            setMessage(res.data.msg);
            setMessageboo(true);
          } else {
            setEmail("");
            setColor("green");
            setMessage("Successful, Thank you for submiting your email");
            setMessageboo(true);
          }
        })
        .catch((_e) => {
          setLoading(false);
          setMessage("An error occurred! Try again");
          setMessageboo(true);
        });
      setTimeout(() => setMessageboo(false), 4000);
    } else {
      setMessage("Please enter a valid email");
      setColor("red");
      setMessageboo(true);
      setTimeout(() => setMessageboo(false), 4000);
    }
  };
  return (
    <div className="container">
      <div className="row jus-con">
        <div className="col-md-6">
          <Fade left>
            <h1>
              Just for first <span>50</span> people
            </h1>
            <p className="p2">
              We will let you know when #TheTribe is available for sale if you
              incldue your email in thee waiting list
            </p>
          </Fade>
        </div>
        <div className="col-md-6 small-mt-3">
          <Fade right>
            <h4 className="text-center jus-title">WHAT IS INSIDE</h4>
            <Slider />
          </Fade>
        </div>
      </div>
      <div className="row mb-5">
        <div className="col-md-6 mb-4">
          <div className="a-our-packages-form">
            <form onSubmit={(e) => handleSubmit(e)}>
              <input
                placeholder="Enter your email here"
                onChange={(e) => {
                  setEmail(e.target.value);
                  setMessageboo(false);
                }}
                value={email}
                className="emailInputs smallestText blackText b4 montserrat inputShadow"
              />
              <input
                value="Join List"
                type="submit"
                className="emailInputs montserrat"
              />
            </form>
            {!loading ? (
              messageboo ? (
                <p style={{ color: color, textAlign: "center" }}>{message}</p>
              ) : null
            ) : (
              <Spinner animation="border" variant="secondary" size="sm" />
            )}
          </div>
        </div>
        <div className="col-md-6 mb-4 d-flex justify-content-end align-items-end">
          <div className="d-flex">
            <p className="p2 mr-3">Share on</p>
            <div>
              <a
                className="mr-3"
                target="_blank"
                rel="noreferrer"
                href="https://www.facebook.com/sharer/sharer.php?u=https://shop.aorthar.com"
              >
                <img src={face} alt="facebook icon" />
              </a>
              <a
                className="mr-3"
                target="_blank"
                rel="noreferrer"
                href="http://twitter.com/intent/tweet/?url=https://shop.aorthar.com"
              >
                <img src={twitter} alt="twitter icon" />
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.instagram.com/?url=https://shop.aorthar.com"
              >
                <img src={insta} alt="instagram icon" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JustForSection;
